import React, { Component } from 'react';
import './_preloader.scss'

class PreloaderTwo extends Component {
    // PreLoaderElement() {
    //     return new Promise(resolve => setTimeout(resolve, 2000))
    // }

    // componentDidMount() {
    //     this.PreLoaderElement().then(() => {
    //         const preloaderEle = document.getElementById('preloader')
    //         if (preloaderEle) {
    //             // fade out
    //             preloaderEle.classList.add('available')
    //             setTimeout(() => {
    //                 // remove from DOM
    //                 preloaderEle.outerHTML = ''
    //             }, 1000)
    //         }
    //     })
    // }

    render() {
        return (
            <div className="preloaderTwo" id="preloader">
                <div className="divLoader">
                    <div className="preloader-skeleton">
                        <div className="ps-shimmer" style={{ width: "35%", height: 24, marginBottom: 20 }} />
                        <div className="ps-shimmer" style={{ width: "100%", height: 52, marginBottom: 16 }} />
                        <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
                            <div className="ps-shimmer" style={{ flex: 1, height: 90 }} />
                            <div className="ps-shimmer" style={{ flex: 1, height: 90 }} />
                            <div className="ps-shimmer" style={{ flex: 1, height: 90 }} />
                        </div>
                        <div className="ps-shimmer" style={{ width: "100%", height: 220, marginBottom: 16 }} />
                        <div className="ps-shimmer" style={{ width: "80%", height: 16, marginBottom: 10 }} />
                        <div className="ps-shimmer" style={{ width: "60%", height: 16 }} />
                    </div>
                </div>
            </div>
        );
    }
}

export default PreloaderTwo;